/**
 * Detect fn
 */
export default () => 'MutationObserver' in self
